import React, { ReactNode, useEffect, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { defaultLocale, mappedLocales, supportedLocales } from './consts';
import LocaleContext from './context';

export const LocaleProvider: React.FC<{
  children?: ReactNode;
  locale?: string;
}> = ({ children, locale }) => {
  const browserLanguage = supportedLocales.find(
    (l) => l === navigator.language,
  );

  const mappedBrowserLanguage = mappedLocales[navigator.language];

  const [customLocale, setCustomLocale] = useState(
    browserLanguage || mappedBrowserLanguage || defaultLocale,
  );

  const context = useMemo(
    () => ({
      locale: locale || customLocale,
      setLocale: setCustomLocale,
    }),
    [customLocale, locale],
  );

  useEffect(() => {
    document.documentElement.lang = locale || customLocale;
  }, [locale, customLocale]);

  return (
    <LocaleContext.Provider value={context}>{children}</LocaleContext.Provider>
  );
};

LocaleProvider.propTypes = {
  locale: PropTypes.string,
};
